// Tipos e helpers das definições da administração da plataforma.

/** GET/PUT /api/admin/settings */
export interface PlatformSettings {
    /** Endereços avisados quando é aberto um novo pedido de suporte. */
    suporteEmails: string[]
}

/** Validação leve, alinhada com a do servidor (PlatformSettingsService). */
export const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

export const SUPORTE_EMAILS_MAX = 20
